const uz = {
    meta: {
        title: "Telegram bot biznes uchun: vazifa va narx | Innobek",
        description:
            "Telegram bot biznes uchun nimani avtomatlashtiradi: tashqi va ichki stsenariylar, narx 9 mln so'mdan, qaytim hisobi va botga bermaslik kerak bo'lgan vazifalar.",
        keywords: [
            "Telegram bot biznes uchun",
            "Telegram bot yaratish narxi",
            "bot orqali buyurtma qabul qilish",
            "bot va CRM integratsiyasi",
            "xodimlar uchun ichki bot",
            "Telegram bot qancha turadi",
        ],
    },
    h1: "Telegram bot bilan nimani avtomatlashtirish mumkin — va nimani aslo kerak emas",
    lead:
        "Bot — savdo kanali emas, u takrorlanuvchi muloqotni yopadigan vosita. Bu maqolada bot real hal qiladigan vazifalar, ichki botning e'tibordan chetda qolgan yo'nalishi, narx va qaytim hisobi hamda bot aniq zarar keltiradigan uchta holat.",
    category: "Avtomatlashtirish",
    readingTime: "9 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Telegram O'zbekistonda eng ommaviy muloqot kanallaridan biri bo'lib qolmoqda va shu sababli bot buyurtmasi ko'payib bormoqda. Lekin loyihalarning katta qismi bitta sababdan natija bermaydi: bot nima uchun kerakligi kod yozilgandan keyin hal qilinadi. Quyida teskari tartib — avval vazifa, keyin bot.",
        },

        { type: "h2", text: "Bot aslida nimani hal qiladi?" },
        {
            type: "p",
            text:
                "Bot bitta ishni yaxshi bajaradi: takrorlanadigan savolga darhol va bir xil javob berish. Narx qancha, manzil qayerda, buyurtmam qayerda, ish vaqti qanday — bu savollar kuniga o'nlab marta kelib, menejer vaqtini yeydi.",
        },
        {
            type: "p",
            text:
                "Bot qila olmaydigan ish ham aniq: u ishontirmaydi, savdolashmaydi va murakkab shartni kelishmaydi. Shuning uchun botni «sotuvchini almashtiradigan narsa» deb ko'rish noto'g'ri. To'g'ri qarash — bot sotuvchini takrorlanuvchi ishdan ozod qiladi va uni faqat pul olib keladigan suhbatga qoldiradi.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Tashqi va ichki bot: ikki mustaqil yo'nalish" },
        {
            type: "p",
            text:
                "Ko'pchilik botni faqat mijoz uchun deb tushunadi. Amalda ikkinchi yo'nalish — xodimlar uchun ichki bot — ko'pincha tezroq va arzonroq natija beradi, chunki unda foydalanuvchini jalb qilish muammosi yo'q: jamoa allaqachon Telegram'da.",
        },
        {
            type: "table",
            head: ["Yo'nalish", "Tipik vazifalar", "Nima o'lchanadi"],
            rows: [
                [
                    "Tashqi bot (mijoz uchun)",
                    "Buyurtma qabul qilish, katalog, to'lov, yetkazib berish holati, navbatga yozilish, eslatma",
                    "Kamaygan qo'ng'iroq soni, ish vaqtidan tashqari olingan ariza",
                ],
                [
                    "Ichki bot (xodim uchun)",
                    "Ta'til va xarajat arizasi, tasdiqlash, kunlik hisobot, smena bildirishnomasi, vazifa biriktirish",
                    "Tasdiqlash vaqti, kechikkan hisobot soni",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Ichki bot ayniqsa dala xodimlari bor kompaniyalarda ishlaydi: montajchi, kuryer, savdo vakili. Ular kompyuter oldida o'tirmaydi, lekin telefonlari doim qo'lida. Hisobotni bot orqali topshirish veb-tizimga kirishdan o'n barobar tezroq.",
        },
        {
            type: "p",
            text:
                "Ichki botning ikkinchi afzalligi — o'lchash osonligi. Tashqi botda natijani mijoz xulqi belgilaydi va uni bashorat qilish qiyin. Ichki botda esa siz tasdiqlash zanjirini bilasiz: ariza qachon berildi, qachon tasdiqlandi, oradan qancha vaqt o'tdi. Shu ikki sanani joriy etishdan oldin va keyin solishtirsangiz, samara raqamda ko'rinadi. Shuning uchun birinchi bot sifatida ichki botni tanlash — byudjetni himoya qilishning eng qisqa yo'li.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Telegram bot qancha turadi?" },
        {
            type: "p",
            text:
                "Narxlar bir martalik va foydalanuvchi soni yoki yuborilgan xabar uchun qo'shimcha haq olinmaydi. Har uchala tarifga olti oylik texnik qo'llab-quvvatlash kiritilgan.",
        },
        {
            type: "table",
            head: ["Tarif", "Narx (so'mdan)", "Muddat", "Nimani yopadi"],
            rows: [
                [
                    "Start",
                    "9 000 000",
                    "2–3 hafta",
                    "Tugmali menyu, ariza qabul qilish, menejerga bildirishnoma, admin panel, ommaviy xabar",
                ],
                [
                    "Business",
                    "24 000 000",
                    "4–7 hafta",
                    "Katalog va savat, Payme hamda Click orqali to'lov, buyurtma holati, CRM yoki 1C integratsiyasi",
                ],
                [
                    "Individual",
                    "Kelishuv asosida",
                    "Loyihaga qarab",
                    "Telegram Mini App, ko'p rolli bot, AI yordamchi, ERP va ichki tizimlar bilan chuqur integratsiya",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Narxga kirmaydiganlar: server yoki bulut xarajati — oddiy bot uchun odatda oyiga 150–400 ming so'm. Payme va Click komissiyasi to'g'ridan-to'g'ri provayderga to'lanadi va shartnomada individual belgilanadi. Kontent — mahsulot tavsifi, rasm va matnlar — sizning tomoningizdan tayyorlanadi.",
        },
        {
            type: "p",
            text:
                "Narxni nima ko'taradi degan savolga javob ham oddiy. Birinchisi — integratsiya soni: har bir tashqi tizim, xoh u CRM, xoh 1C, xoh to'lov provayderi bo'lsin, alohida ish talab qiladi. Ikkinchisi — rollar soni: mijoz, kuryer, menejer va rahbar uchun alohida ekran degani deyarli to'rtta bot degani. Uchinchisi — katalog hajmi va uning qayerdan yangilanishi: qo'lda kiritiladigan yuz pozitsiya bilan boshqa tizimdan avtomatik tortiladigan besh ming pozitsiya bir xil ish emas.",
        },

        { type: "h2", text: "Bot qachon o'zini oqlaydi — ochiq hisob" },
        {
            type: "p",
            text:
                "Model kompaniya olamiz: xizmat ko'rsatuvchi biznes, oyiga 600 ta murojaat Telegram va telefon orqali keladi. Shulardan 65 foizi takrorlanuvchi savol — narx, manzil, ish vaqti, buyurtma holati. Bu 390 ta murojaat demakdir.",
        },
        {
            type: "list",
            items: [
                "Tejalgan vaqt: 390 × 4 daqiqa = 1 560 daqiqa, ya'ni oyiga 26 soat. Soat tannarxi 45 000 so'm bo'lsa — 1 170 000 so'm.",
                "Yo'qotilmagan ariza: murojaatlarning 30 foizi ish vaqtidan tashqari keladi — 180 ta. Shundan 10 foizi ertasiga javob kutmay ketadi — 18 ta ariza.",
                "Yo'qotilgan tushum: 18 × 15% konversiya × 1,5 mln so'm o'rtacha chek ≈ 4 mln so'm.",
            ],
        },
        {
            type: "p",
            text:
                "Jami oyiga taxminan 5,2 mln so'm. Start tarifi 9 mln so'mdan. Agar bot bu yo'qotishning yarmini yopsa — oyiga 2,6 mln so'm — qaytish muddati 9 ÷ 2,6 ≈ 3,5 oy. Bu realroq hisob, chunki bot hamma savolni yopmaydi: foydalanuvchining bir qismi baribir jonli odamga yozadi.",
        },
        {
            type: "callout",
            text:
                "O'z hisobingizni qiling: oyiga nechta murojaat kelayotganini va ulardan qanchasi takrorlanuvchi savol ekanini bir hafta davomida sanab chiqing. Bu bir hafta butun byudjet qaroridan muhimroq.",
        },

        { type: "h2", text: "Bot CRM'ga ulanmasa nima bo'ladi?" },
        {
            type: "p",
            text:
                "Alohida turgan bot — bu yana bitta joyda saqlanadigan ma'lumot. Ariza botda qoladi, menejer uni qo'lda ko'chiradi, ko'chirish esa unutiladi. Natijada bot muammoni yechish o'rniga yangi nusxa yaratadi.",
        },
        {
            type: "p",
            text:
                "To'g'ri sxema oddiy: botdagi ariza darhol CRM'da bitim kartochkasiga aylanadi, menejerga biriktiriladi va unga bildirishnoma ketadi. Mijoz javob yozsa, u ham shu kartochkada ko'rinadi. Shunda konversiyani o'lchash mumkin bo'ladi — bot nechta ariza berdi va ulardan nechtasi bitimga aylandi.",
        },
        {
            type: "p",
            text:
                "Amaliyotimizdagi tavsiya: agar CRM hali yo'q bo'lsa, botni Google Sheets yoki oddiy admin panelga ulash ham ish beradi. Muhimi — ariza bir joyda to'planishi. Eng yomon variant — ariza faqat menejerning shaxsiy chatida qolishi.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Nimani botga aslo bermaslik kerak?" },
        {
            type: "p",
            text:
                "Bu bo'lim eng muhimi. Quyidagi uchta vazifada bot foyda emas, zarar keltiradi — mijoz g'azablanadi va ko'pincha qaytib kelmaydi.",
        },
        {
            type: "list",
            items: [
                "Murakkab kelishuv. Katta chek, individual shart, bosqichma-bosqich to'lov — bu yerda mijoz odam bilan gaplashishi kerak. Bot uni tugmalar labirintiga qamab qo'yadi.",
                "Shikoyat va nizo. Mijoz asabiylashganda avtomatik javob vaziyatni og'irlashtiradi. Shikoyat birinchi xabardanoq jonli operatorga o'tishi shart.",
                "Tibbiy, yuridik va moliyaviy maslahat. Bot javobi uchun javobgarlikni bot ko'tarmaydi — uni siz ko'tarasiz. Bunday savollar faqat mutaxassisga yo'naltiriladi.",
            ],
        },
        {
            type: "p",
            text:
                "Amaliy qoida: har qanday stsenariyda «operatorga ulanish» tugmasi ikkinchi qadamdan uzoqroqda bo'lmasin. Foydalanuvchi bot bilan gaplashishga majburmi degan his paydo bo'lsa, siz botdan emas, mijozdan ayrilasiz.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Botga AI qatlamini qo'shish arziydimi?" },
        {
            type: "p",
            text:
                "Tugmali bot faqat oldindan yozilgan stsenariyni biladi. AI qatlami erkin yozilgan savolni tushunadi va bazadagi ma'lumot asosida javob beradi. Bu foydali, lekin faqat bitta shart bilan: javob manbayi sizning hujjatlaringiz bo'lishi kerak, aks holda bot ishonch bilan noto'g'ri javob beradi.",
        },
        {
            type: "p",
            text:
                "2026-yilda bu yo'nalish arzonlashdi. «10 000 korxona uchun AI-hamkor» dasturi doirasida bizneslarga sun'iy intellekt joriy etish xarajatlarining 50 foizi qoplab beriladi. Dasturning joriy shartlari va ariza tartibini rasmiy operatordan tekshirib oling — qamrov va muddat o'zgarishi mumkin.",
        },
        {
            type: "p",
            text:
                "Boshlash tartibi esa o'zgarmaydi: avval tugmali bot ishga tushadi, uch oy davomida haqiqiy savollar yig'iladi, keyin shu savollar asosida AI qatlami quriladi. Teskari tartibda AI nimaga javob berishini bilmaydi.",
        },

        { type: "h2", text: "Bot qachon kerak emas?" },
        {
            type: "p",
            text:
                "Bot har biznesga foyda keltirmaydi. Quyidagi holatlarda 9 mln so'm boshqa joyga sarflansa, natija ko'proq bo'ladi.",
        },
        {
            type: "list",
            items: [
                "Murojaat oz. Oyiga 50 tagacha xabar kelsa, menejer ularni qo'lda ham uddalaydi.",
                "Har buyurtma noyob. Loyiha ishlari, individual ishlab chiqarish — bu yerda stsenariy tuzib bo'lmaydi.",
                "Kontent yo'q. Katalog, narx va tavsif tayyor bo'lmasa, bot bo'sh qobiq bo'lib qoladi.",
                "Botni yurituvchi yo'q. Arizaga javob beradigan odam belgilanmagan bo'lsa, bot javobsiz xabarlar omboriga aylanadi.",
            ],
        },
        {
            type: "p",
            text:
                "Elektron tijorat o'sishi botni savdo kanali sifatida ishlatishga turtki bermoqda: 2025-yil yakuni bo'yicha O'zbekistonda elektron tijorat aylanmasi 22,7 trln so'mni tashkil etdi, bu oldingi yilga nisbatan 1,5 barobar ko'p. Lekin o'sish o'zi sizning botingizni foydali qilmaydi — buni yuqoridagi hisob qiladi.",
        },
    ],

    faq: [
        {
            q: "Telegram bot yaratish qancha turadi?",
            a: "Start tarifi 9 mln so'mdan, muddati 2–3 hafta: tugmali menyu, ariza qabul qilish, menejerga bildirishnoma va admin panel. Business 24 mln so'mdan, muddati 4–7 hafta: katalog, savat, Payme va Click orqali to'lov hamda CRM integratsiyasi. Server xarajati alohida — oddiy bot uchun odatda oyiga 150–400 ming so'm.",
        },
        {
            q: "Bot qancha vaqtda o'zini oqlaydi?",
            a: "Model hisobda oyiga 600 murojaat keladigan kompaniya uchun taxminan 3,5 oy. Hisob ikki qismdan iborat: takrorlanuvchi savollarga ketgan menejer soatlari va ish vaqtidan tashqari yo'qolgan arizalar. O'z raqamingizni qo'ying — oyiga nechta murojaat va ulardan qanchasi bir xil savol ekanini bir hafta sanab chiqing.",
        },
        {
            q: "Bot menejerni almashtira oladimi?",
            a: "Yo'q va bunga urinmang. Bot takrorlanuvchi savolni yopadi, menejerni esa pul olib keladigan suhbatga bo'shatadi. Murakkab kelishuv, katta chekdagi savdo va shikoyat har doim jonli odamga o'tishi kerak. Amaliy qoida: «operatorga ulanish» tugmasi har qanday stsenariyda ikkinchi qadamdan uzoqda bo'lmasin.",
        },
        {
            q: "Botni CRM'ga ulash shartmi?",
            a: "Shart emas, lekin ulanmagan bot ma'lumotning yana bitta nusxasini yaratadi va arizalar menejerning shaxsiy chatida qoladi. CRM bo'lmasa, botni Google Sheets yoki admin panelga ulash ham yetadi. Muhimi — barcha ariza bir joyda to'plansin, shunda bot nechta bitim berganini o'lchash mumkin bo'ladi.",
        },
        {
            q: "Ichki bot nima uchun kerak?",
            a: "Ichki bot xodimlar uchun ishlaydi: ta'til va xarajat arizasi, tasdiqlash, kunlik hisobot, smena bildirishnomasi, vazifa biriktirish. U dala xodimlari bor kompaniyalarda ayniqsa foydali — montajchi yoki kuryer kompyuter oldida o'tirmaydi. Bunday botda foydalanuvchini jalb qilish muammosi yo'q, chunki jamoa allaqachon Telegram'da.",
        },
        {
            q: "Botga sun'iy intellekt qo'shish kerakmi?",
            a: "Avval tugmali botni ishga tushiring va uch oy davomida haqiqiy savollarni yig'ing. Shundan keyin AI qatlami nimaga javob berishi kerakligi aniq bo'ladi. Muhim shart: javob manbayi sizning hujjatlaringiz bo'lsin, aks holda bot ishonch bilan noto'g'ri javob beradi. Qo'llab-quvvatlash dasturlari shartlarini rasmiy operatordan tekshiring.",
        },
    ],

    cta: {
        h: "Bot sizga foydali bo'ladimi — bepul aniqlaymiz",
        p:
            "Murojaatlaringiz tarkibini ko'ramiz, qaysi stsenariylarni bot yopa olishini va qaysilari odamda qolishi kerakligini aytamiz, keyin taxminiy byudjet beramiz. Bot sizga kerak bo'lmasa, buni ochiq aytamiz.",
        button: "Bepul konsultatsiya",
    },

    images: [
        {
            src: "/assets/img/projects/tamamuzbot.webp",
            alt: "Tamamuz bot interfeysi — foydalanuvchi bilan muloqot va menyu ekrani",
            caption: "Tamamuz bot: tugmali stsenariy va ariza qabul qilish oqimi",
        },
        {
            src: "/assets/img/blog/telegram-bot-tashqi-va-ichki.webp",
            alt: "Tashqi va ichki botlarning vazifalari bo'yicha ikki tarmoqqa ajratilishi",
            caption: "Ikki mustaqil yo'nalish: mijoz uchun bot va xodim uchun bot",
            prompt:
                "Two-branch diagram: left branch external bot use-cases (order, delivery status, booking, reminder) and right branch internal bot use-cases (request approval, daily report, shift notification, task assignment), each with small icons; clean flat vector, blue and teal, no text placeholders, 16:9",
        },
        {
            src: "/assets/img/blog/telegram-bot-crm-integratsiya.webp",
            alt: "Botdagi xabarning CRM'dagi bitim kartochkasiga aylanish sxemasi",
            caption: "Ariza botda qolmasligi kerak — u CRM kartochkasiga aylanadi",
            prompt:
                "Integration illustration: chat bubble stream on the left flowing into a CRM deal card on the right, with a webhook arrow and a notification bell; minimal light UI, blue accent, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/telegram-bot-qachon-ishlamaydi.webp",
            alt: "Bot yordam bera olmaydigan uchta vaziyat: murakkab kelishuv, shikoyat, katta chek",
            caption: "Uchta holatda bot foyda emas, zarar keltiradi",
            prompt:
                "Red-flag panel: three cards showing scenarios where a bot fails — complex negotiation, emotional complaint, high-value custom order; muted red accents, simple line icons, clean light background, no readable text, 4:3",
        },
    ],

    relatedServices: ["telegram-bot", "crm-tizimlar", "biznes-avtomatlashtirish"],
    relatedPosts: [
        "biznes-avtomatlashtirish-yol-xaritasi",
        "tayyor-crm-yoki-oz-crm-tco",
        "excel-dan-erp-ga-otish-signallari",
    ],
};

const ru = {
    meta: {
        title: "Telegram-бот для бизнеса: задачи и цена | Innobek",
        description:
            "Что автоматизирует Telegram-бот для бизнеса: внешние и внутренние сценарии, цена от 9 млн сум, расчёт окупаемости и задачи, которые боту отдавать нельзя.",
        keywords: [
            "Telegram-бот для бизнеса Узбекистан",
            "разработка Telegram-бота цена",
            "приём заказов через бота",
            "интеграция бота с CRM",
            "внутренний бот для сотрудников",
            "сколько стоит Telegram-бот",
        ],
    },
    h1: "Что можно автоматизировать Telegram-ботом — и чего делать не стоит",
    lead:
        "Бот — не канал продаж, а инструмент, который закрывает повторяющиеся диалоги. В статье: какие задачи бот действительно решает, недооценённое направление внутренних ботов, цена и расчёт окупаемости, а также три ситуации, где бот вредит.",
    category: "Автоматизация",
    readingTime: "9 минут",

    body: [
        {
            type: "p",
            text:
                "Telegram остаётся одним из основных каналов общения в Узбекистане, и заказов на ботов становится больше. Но значительная часть проектов не даёт результата по одной причине: зачем нужен бот, решают уже после того, как написан код. Ниже обратный порядок — сначала задача, потом бот.",
        },

        { type: "h2", text: "Что бот решает на самом деле?" },
        {
            type: "p",
            text:
                "Бот хорошо делает одно: мгновенно и одинаково отвечает на повторяющийся вопрос. Сколько стоит, где вы находитесь, где мой заказ, до скольки работаете — такие вопросы приходят десятками в день и съедают время менеджера.",
        },
        {
            type: "p",
            text:
                "Чего бот не умеет, тоже понятно: он не убеждает, не торгуется и не согласовывает сложные условия. Поэтому смотреть на бота как на замену продавцу неверно. Правильная рамка другая: бот освобождает продавца от повторяющейся работы и оставляет ему только те разговоры, которые приносят деньги.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Внешний и внутренний бот: два самостоятельных направления" },
        {
            type: "p",
            text:
                "Бота обычно представляют только как инструмент для клиента. На практике второе направление — внутренний бот для сотрудников — нередко даёт результат быстрее и дешевле: здесь нет проблемы привлечения пользователей, команда уже в Telegram.",
        },
        {
            type: "table",
            head: ["Направление", "Типовые задачи", "Что измеряется"],
            rows: [
                [
                    "Внешний бот (для клиента)",
                    "Приём заказа, каталог, оплата, статус доставки, запись в очередь, напоминание",
                    "Снижение числа звонков, заявки, полученные вне рабочего времени",
                ],
                [
                    "Внутренний бот (для сотрудника)",
                    "Заявка на отпуск и расходы, согласование, ежедневный отчёт, уведомление о смене, постановка задачи",
                    "Время согласования, число просроченных отчётов",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Внутренний бот особенно хорошо работает там, где есть полевые сотрудники: монтажники, курьеры, торговые представители. Они не сидят за компьютером, но телефон всегда в руке. Сдать отчёт через бота в десять раз быстрее, чем зайти в веб-систему.",
        },
        {
            type: "p",
            text:
                "Второе преимущество внутреннего бота — его легко измерить. Во внешнем результат зависит от поведения клиента, а его трудно предсказать. Во внутреннем вы знаете цепочку согласования: когда подана заявка, когда она утверждена, сколько прошло времени. Сравните эти две отметки до и после внедрения — и эффект окажется в цифрах. Поэтому начать с внутреннего бота — часто самый короткий путь к защите бюджета.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Сколько стоит Telegram-бот?" },
        {
            type: "p",
            text:
                "Цены разовые, доплаты за количество пользователей или отправленных сообщений нет. Во все три тарифа входит шесть месяцев технической поддержки.",
        },
        {
            type: "table",
            head: ["Тариф", "Цена (от, сум)", "Срок", "Что закрывает"],
            rows: [
                [
                    "Start",
                    "9 000 000",
                    "2–3 недели",
                    "Кнопочное меню, приём заявок, уведомление менеджеру, админ-панель, массовая рассылка",
                ],
                [
                    "Business",
                    "24 000 000",
                    "4–7 недель",
                    "Каталог и корзина, оплата через Payme и Click, статус заказа, интеграция с CRM или 1С",
                ],
                [
                    "Individual",
                    "По договорённости",
                    "Зависит от проекта",
                    "Telegram Mini App, многоролевой бот, ИИ-помощник, глубокая интеграция с ERP и внутренними системами",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Что не входит в цену: сервер или облако — для простого бота обычно 150–400 тысяч сум в месяц. Комиссия Payme и Click платится напрямую провайдеру и определяется договором индивидуально. Контент — описания товаров, фотографии и тексты — готовите вы.",
        },
        {
            type: "p",
            text:
                "Что поднимает цену, объяснить несложно. Первое — число интеграций: каждая внешняя система, будь то CRM, 1С или платёжный провайдер, требует отдельной работы. Второе — число ролей: отдельные экраны для клиента, курьера, менеджера и руководителя означают почти четыре разных бота. Третье — объём каталога и способ его обновления: сто позиций, заполняемых вручную, и пять тысяч, подтягиваемых из другой системы, — это разные задачи.",
        },

        { type: "h2", text: "За какой срок бот окупается?" },
        {
            type: "p",
            text:
                "Возьмём модельную компанию: сервисный бизнес, 600 обращений в месяц через Telegram и телефон. Из них 65 процентов — повторяющиеся вопросы про цену, адрес, часы работы и статус заказа. Это 390 обращений.",
        },
        {
            type: "list",
            items: [
                "Сэкономленное время: 390 × 4 минуты = 1 560 минут, то есть 26 часов в месяц. При себестоимости часа 45 000 сум — 1 170 000 сум.",
                "Потерянные заявки: 30 процентов обращений приходят вне рабочего времени — 180 штук. Из них 10 процентов уходят, не дождавшись ответа — 18 заявок.",
                "Недополученная выручка: 18 × 15% конверсии × 1,5 млн сум среднего чека ≈ 4 млн сум.",
            ],
        },
        {
            type: "p",
            text:
                "Итого около 5,2 млн сум в месяц. Тариф Start стоит от 9 млн сум. Если бот закроет половину этих потерь — 2,6 млн в месяц — окупаемость составит 9 ÷ 2,6 ≈ 3,5 месяца. Это более честная оценка: бот не снимает все вопросы, часть пользователей всё равно пишет живому человеку.",
        },
        {
            type: "callout",
            text:
                "Посчитайте сами: в течение недели фиксируйте, сколько обращений приходит и какая доля из них — повторяющиеся вопросы. Эта неделя важнее любого решения по бюджету.",
        },

        { type: "h2", text: "Что будет, если бот не связан с CRM?" },
        {
            type: "p",
            text:
                "Отдельно стоящий бот — это ещё одно место хранения данных. Заявка остаётся в боте, менеджер переносит её вручную, а перенос забывается. В итоге бот не решает проблему, а создаёт новую копию.",
        },
        {
            type: "p",
            text:
                "Правильная схема проста: заявка из бота сразу становится карточкой сделки в CRM, закрепляется за менеджером, и ему уходит уведомление. Ответ клиента тоже виден в этой карточке. Только тогда конверсию можно измерить: сколько заявок дал бот и сколько из них стали сделками.",
        },
        {
            type: "p",
            text:
                "Практическая рекомендация: если CRM пока нет, подойдёт связка бота с Google Sheets или простой админ-панелью. Важно, чтобы заявки собирались в одном месте. Худший вариант — когда заявка остаётся только в личном чате менеджера.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Что боту отдавать нельзя?" },
        {
            type: "p",
            text:
                "Это самый важный раздел. В трёх задачах ниже бот приносит не пользу, а вред: клиент раздражается и чаще всего не возвращается.",
        },
        {
            type: "list",
            items: [
                "Сложное согласование. Крупный чек, индивидуальные условия, поэтапная оплата — здесь клиенту нужен человек. Бот загоняет его в лабиринт кнопок.",
                "Жалоба и конфликт. Когда клиент раздражён, автоматический ответ только усугубляет ситуацию. Жалоба должна уходить живому оператору с первого же сообщения.",
                "Медицинские, юридические и финансовые консультации. Ответственность за ответ бота несёт не бот, а вы. Такие вопросы переводятся только на специалиста.",
            ],
        },
        {
            type: "p",
            text:
                "Практическое правило: кнопка «связаться с оператором» не должна быть дальше второго шага ни в одном сценарии. Как только у пользователя появляется ощущение, что его заставляют говорить с ботом, вы теряете не бота, а клиента.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Стоит ли добавлять к боту искусственный интеллект?" },
        {
            type: "p",
            text:
                "Кнопочный бот знает только заранее прописанный сценарий. Слой ИИ понимает вопрос в свободной форме и отвечает на основе вашей базы знаний. Это полезно, но при одном условии: источником ответа должны быть ваши документы, иначе бот уверенно выдаст неверный ответ.",
        },
        {
            type: "p",
            text:
                "В 2026 году это направление подешевело. В рамках программы «ИИ-партнёр для 10 000 предприятий» бизнесу компенсируется 50 процентов затрат на внедрение искусственного интеллекта. Актуальные условия и порядок подачи заявки уточняйте у официального оператора программы — охват и сроки могут меняться.",
        },
        {
            type: "p",
            text:
                "Порядок запуска при этом не меняется: сначала работает кнопочный бот, три месяца собираются реальные вопросы пользователей, и только затем на их основе строится слой ИИ. В обратной последовательности модель просто не знает, на что отвечать.",
        },

        { type: "h2", text: "Когда бот не нужен?" },
        {
            type: "p",
            text:
                "Бот полезен не каждому бизнесу. В перечисленных ситуациях 9 млн сум принесут больше результата в другом месте.",
        },
        {
            type: "list",
            items: [
                "Обращений мало. При 50 сообщениях в месяц менеджер справляется вручную.",
                "Каждый заказ уникален. Проектные работы и индивидуальное производство не укладываются в сценарий.",
                "Нет контента. Без готового каталога, цен и описаний бот останется пустой оболочкой.",
                "Некому вести бота. Если не назначен человек, отвечающий на заявки, бот превратится в склад сообщений без ответа.",
            ],
        },
        {
            type: "p",
            text:
                "Рост электронной коммерции подталкивает использовать бота как канал продаж: по итогам 2025 года оборот электронной торговли в Узбекистане составил 22,7 трлн сум — в полтора раза больше, чем годом ранее. Но сам по себе рост рынка не сделает ваш бот выгодным — выгодным его делает расчёт выше.",
        },
    ],

    faq: [
        {
            q: "Сколько стоит разработка Telegram-бота?",
            a: "Тариф Start — от 9 млн сум, срок 2–3 недели: кнопочное меню, приём заявок, уведомление менеджеру и админ-панель. Business — от 24 млн сум, срок 4–7 недель: каталог, корзина, оплата через Payme и Click, интеграция с CRM. Сервер оплачивается отдельно — для простого бота обычно 150–400 тысяч сум в месяц.",
        },
        {
            q: "За какой срок бот окупается?",
            a: "В модельном расчёте для компании с 600 обращениями в месяц — примерно 3,5 месяца. Расчёт состоит из двух частей: часы менеджера, уходящие на повторяющиеся вопросы, и заявки, потерянные вне рабочего времени. Подставьте свои цифры: неделю считайте объём обращений и долю одинаковых вопросов среди них.",
        },
        {
            q: "Может ли бот заменить менеджера?",
            a: "Нет, и не стоит пытаться. Бот закрывает повторяющиеся вопросы и освобождает менеджера для разговоров, которые приносят деньги. Сложные согласования, продажи с крупным чеком и жалобы всегда должны переходить к человеку. Практическое правило: кнопка перехода на оператора не дальше второго шага в любом сценарии.",
        },
        {
            q: "Обязательно ли связывать бота с CRM?",
            a: "Не обязательно, но несвязанный бот создаёт ещё одну копию данных, и заявки оседают в личном чате менеджера. Если CRM пока нет, подойдёт связка с Google Sheets или админ-панелью. Главное, чтобы все заявки собирались в одном месте — тогда можно измерить, сколько сделок принёс бот.",
        },
        {
            q: "Зачем нужен внутренний бот?",
            a: "Внутренний бот работает на сотрудников: заявки на отпуск и расходы, согласования, ежедневные отчёты, уведомления о сменах, постановка задач. Особенно полезен там, где есть полевой персонал — монтажник или курьер не сидит за компьютером. Проблемы привлечения пользователей здесь нет, команда уже в Telegram.",
        },
        {
            q: "Нужно ли добавлять к боту искусственный интеллект?",
            a: "Сначала запустите кнопочный бот и три месяца собирайте реальные вопросы. После этого станет ясно, на что именно должен отвечать слой ИИ. Важное условие: источником ответов должны быть ваши документы, иначе бот уверенно выдаст неверную информацию. Условия программ поддержки уточняйте у официального оператора.",
        },
    ],

    cta: {
        h: "Бесплатно определим, нужен ли вам бот",
        p:
            "Посмотрим структуру ваших обращений, скажем, какие сценарии бот закроет, а какие должны остаться за человеком, и назовём примерный бюджет. Если бот вам не нужен, скажем об этом прямо.",
        button: "Получить консультацию",
    },

    images: [
        {
            src: "/assets/img/projects/tamamuzbot.webp",
            alt: "Интерфейс бота Tamamuz — экран диалога с пользователем и меню",
            caption: "Tamamuz: кнопочный сценарий и поток приёма заявок",
        },
        {
            src: "/assets/img/blog/telegram-bot-tashqi-va-ichki.webp",
            alt: "Разделение задач внешнего и внутреннего ботов на две ветви",
            caption: "Два самостоятельных направления: бот для клиента и бот для сотрудника",
            prompt:
                "Two-branch diagram: left branch external bot use-cases (order, delivery status, booking, reminder) and right branch internal bot use-cases (request approval, daily report, shift notification, task assignment), each with small icons; clean flat vector, blue and teal, no text placeholders, 16:9",
        },
        {
            src: "/assets/img/blog/telegram-bot-crm-integratsiya.webp",
            alt: "Схема превращения сообщения в боте в карточку сделки в CRM",
            caption: "Заявка не должна оставаться в боте — она становится карточкой в CRM",
            prompt:
                "Integration illustration: chat bubble stream on the left flowing into a CRM deal card on the right, with a webhook arrow and a notification bell; minimal light UI, blue accent, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/telegram-bot-qachon-ishlamaydi.webp",
            alt: "Три ситуации, в которых бот не помогает: сложное согласование, жалоба, крупный заказ",
            caption: "В трёх ситуациях бот приносит не пользу, а вред",
            prompt:
                "Red-flag panel: three cards showing scenarios where a bot fails — complex negotiation, emotional complaint, high-value custom order; muted red accents, simple line icons, clean light background, no readable text, 4:3",
        },
    ],

    relatedServices: ["telegram-bot", "crm-tizimlar", "biznes-avtomatlashtirish"],
    relatedPosts: [
        "biznes-avtomatlashtirish-yol-xaritasi",
        "tayyor-crm-yoki-oz-crm-tco",
        "excel-dan-erp-ga-otish-signallari",
    ],
};

const content = { uz, ru };

export default content;
